module.exports = __webpack_public_path__ + "static/media/22770617_1629548200453698_4609590619251632469_o.335cdc1b.jpg";